export const CrdpConfig = {
  layout: {
    // Set to true to enable the left sidebar menu, false to disable it
    enableLeftMenu: true,
    // Other layout options can be added here in the future
    // enableBreadcrumbs: true,
    // enablePageTitle: true,
  },

  // Authentication Configuration
  auth: {
    // Set to true to require authentication for protected routes
    requireAuth: true,
    // Set to true to remember user login state
    enableRememberMe: true,
  },

  // Application Information
  app: {
    name: 'Customer Relationship Data Platform',
    version: '2.0.0',
  },
};

export const isLeftMenuEnabled = () => CrdpConfig.layout.enableLeftMenu;